import sceneWindDown from '../assets/art/scene-wind-down.svg?raw'
import { svgFromRaw } from '../assets/art/svg'
import { el } from '../dom'
import { COPY } from './copy'

export function createWinddown(): { root: HTMLElement; show: () => void; hide: () => void } {
  const root = el(
    'section',
    {
      className: 'winddown',
      testId: 'winddown',
      attrs: { hidden: '' },
    },
    [
      svgFromRaw(sceneWindDown, 'winddown__art'),
      el('p', { className: 'winddown__line', text: COPY.winddown }),
    ],
  )
  return {
    root,
    show: () => {
      root.hidden = false
    },
    hide: () => {
      root.hidden = true
    },
  }
}
